import { render, staticRenderFns } from "./ApprovalHeadForm.vue?vue&type=template&id=fd331d2e&scoped=true"
import script from "./ApprovalHeadForm.vue?vue&type=script&lang=js"
export * from "./ApprovalHeadForm.vue?vue&type=script&lang=js"
import style0 from "./ApprovalHeadForm.vue?vue&type=style&index=0&id=fd331d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd331d2e",
  null
  
)

export default component.exports